import { render, staticRenderFns } from "./RegionTop.vue?vue&type=template&id=71146f8c&scoped=true"
import script from "./RegionTop.vue?vue&type=script&lang=js"
export * from "./RegionTop.vue?vue&type=script&lang=js"
import style0 from "./RegionTop.vue?vue&type=style&index=0&id=71146f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71146f8c",
  null
  
)

export default component.exports